import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

import { IconCTA } from 'Src/components/buttons/IconCTA';
import { Clock } from 'Src/components/Clock';
import Copy from 'Src/components/Copy';
import { SalidoIcon } from 'Src/components/icons/svg/SalidoIcon';
import { Flex } from 'Src/components/layout/Flex';
import { Terminal } from 'Src/feature/terminal/terminalService';
import { definitions } from 'Src/vendor/posapi/pos';

import styles from './TerminalDetails.module.scss';

interface TerminalDetailsProps {
  terminal: Terminal | undefined;
  location: definitions['types.Location'] | undefined;
}

const TerminalDetails: FC<TerminalDetailsProps> = ({
  terminal,
  location,
}) => {
  const { t } = useTranslation();

  return (
    <Flex>
      <div className={styles.input_spacer} />
      <SalidoIcon />
      <Flex grow justifyContent="end">
        <Clock
          render={({ time, meridian }) => (
            <Flex className={styles.clock} gap="sm">
              <Flex horizontal gap="none">
                <Copy variant="h3" value={time} />
                <Copy variant="h3" value={meridian} />
              </Flex>
              <Copy variant="body" size="lg" value={DateTime.local().toLocaleString(DateTime.DATE_HUGE)} />
            </Flex>
          )}
        />
        <Copy value={terminal?.name} />
        <Copy value={location?.name} />
        {/* Wrapping the IconCTA in a div so that it doesn't center itself within the Flex container */}
        <div>
          <IconCTA icon="download" onClick={() => window.location.reload()}>
            <Copy className={styles.btnLabel} variant="body" weight="semi-bold" value={t('labels.versionUpdate')} />
          </IconCTA>
        </div>
      </Flex>
      <div className={styles.input_validation_spacer} />
    </Flex>
  );
};

export { TerminalDetails };
